import fixedFieldChoices from '../../../helpers/intakeForms/fixedFieldChoices'

/**
 * Het keuzemenu 'VAST GEGEVEN' in de formulierbouwer: aan welk vast gegeven van
 * het huishouden deze vraag gekoppeld is. Een gekoppeld antwoord komt op de
 * kaart 'Vaste gegevens' in plaats van als eigen gegeven (T12/T13).
 * Gestuurd (`value`), want de keuze komt uit Firestore en kan later binnenkomen.
 * AI-CONTEXT: See docs/pitfalls.md#ui-select-defaultvalue-loses-late-options
 * AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md (T13)
 *
 * @param {object} props
 * @param {{ID?: string, FixedFieldKey?: string}} props.field - De vraag
 * @param {Array<{ID?: string, FixedFieldKey?: string}>} props.fields - Alle vragen van het formulier
 * @param {(key: string) => void} props.onChange - Met de gekozen sleutel, of '' voor ontkoppelen
 */
const FixedFieldSelect = ({ field, fields, onChange }) => (
    <select
        aria-label="Vast gegeven"
        className="intake-fixed-field-select"
        value={field?.FixedFieldKey || ''}
        onChange={(e) => onChange(e.target.value)}
    >
        {fixedFieldChoices(fields, field?.ID).map((choice) => (
            <option key={choice.value || 'geen'} value={choice.value} disabled={choice.disabled}>{choice.label}</option>
        ))}
    </select>
)

export default FixedFieldSelect
